import { render } from "./NotificationButton.vue?vue&type=template&id=2a3cc8a2&scoped=true&ts=true"
import script from "./NotificationButton.vue?vue&type=script&lang=ts"
export * from "./NotificationButton.vue?vue&type=script&lang=ts"

import "./NotificationButton.vue?vue&type=style&index=0&id=2a3cc8a2&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3cc8a2"]])

export default __exports__